export default function RegexField({formId, regexField, answers, setAnswers}) {
	return (
		<div className={"mb-3"}>
			<label htmlFor={formId + regexField.id} className={"form-label"}>{regexField.name}:</label>
			<input pattern={regexField.regex} title={regexField.title} form={formId} required={regexField.required} type={"text"} id={formId + regexField.id} className={"form-control"} value={answers.regexFields.find(value => value.id === regexField.id).value} onChange={evt => {
				setAnswers(prev => {
					const newState = {...prev};
					const newRegexFields = [
						...newState.regexFields
					];
					newState.regexFields = newRegexFields;


					newRegexFields.find(value => value.id === regexField.id).value = evt.target.value;
					return newState;
				});
			}} />
		</div>
	);
}
